import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FiSearch, FiChevronDown } from 'react-icons/fi';
import { RxCross2 } from 'react-icons/rx';

import { searchbarActions, bookAppointmentActions } from '../../../store';

import './SearchDropdown.css';
import { selectLanguage } from '../../../store/languageSlice';
import { clearWebsiteDoctorName } from '../../../store/websiteReferrerSlice';

const SearchDropdown = ({
  getInputValueHandler,
  searchType,
  onFocus,
}) => {
  const dispatch = useDispatch();
  const searchText = useSelector((state) => state.searchbar.searchText);
  const { t, isRtl } = useSelector(selectLanguage);
  const websiteSelectedDoctor = useSelector((state) => state.websiteReferrer.websiteSelectedDoctorName);

  const getInputValueHandlerRef = useRef(getInputValueHandler);
  useEffect(() => {
    getInputValueHandlerRef.current = getInputValueHandler;
  }, [getInputValueHandler]);

  const clearInputFieldHandler = () => {
    getInputValueHandlerRef.current('');
    dispatch(searchbarActions.updateSearchText(''));
  };
  
  // const clearInputFieldHandler = () => {
  //   getInputValueHandler('');
  //   dispatch(searchbarActions.updateSearchText(''));
  // };

  const chnageInputFieldHandler = (e) => {
    const typedValue = e.target.value;

    if (typedValue !== "" && typedValue.trim() === "") {
      return;
    }

    getInputValueHandlerRef.current(typedValue);
    dispatch(searchbarActions.updateSearchText(typedValue));
    if(websiteSelectedDoctor){
      localStorage.removeItem("selectedWebsiteDoctorName")
      dispatch(clearWebsiteDoctorName());
    }
  };

  // const chnageInputFieldHandler = (e) => {
  //   const typedValue = e.target.value
  //   getInputValueHandler(typedValue);
  //   dispatch(searchbarActions.updateSearchText(typedValue));
  // };  

  useEffect(()=>{
    if(websiteSelectedDoctor){
      setTimeout(() => {
        getInputValueHandlerRef.current(websiteSelectedDoctor);
        dispatch(searchbarActions.updateSearchText(websiteSelectedDoctor));
      }, 1000);
    }
  },[websiteSelectedDoctor])

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     var docName = "nebras";
  //     console.log("doctor name =>>> ", docName);
  //     getInputValueHandlerRef.current(docName);
  //     dispatch(searchbarActions.updateSearchText(docName));
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, []);

  const focusHandler = () => {
    onFocus && onFocus();
  };

  useEffect(()=>{
    clearInputFieldHandler();
  },[isRtl])

  return (
    <div className="docOrClincSrch">
      <div className="flex flex-wrap items-center">
        <span className="text-primary">
          <FiSearch />
        </span>
        <input
          type="text"
          value={searchText}
          onChange={(e) => {
            chnageInputFieldHandler(e)
          }}
          placeholder={`${t.Searchby} ${t.Doctor}/ ${
            searchType === 'Clinic'
              ? t.Clinic
              : t.Symptoms
          }`}
        />

        <span className="text-secondary cursor-pointer" onClick={focusHandler}>
          <FiChevronDown />
        </span>
      </div>
    </div>
  );
};

export default SearchDropdown;
